import { useEffect, useState } from "react";
import CreateAccountV2 from "./components/steps/CreateAccountV2";

import ProfileCompletionCard from "./components/ProfileCompletionCard";
import ProfileCompletionTopPopup from "./components/ProfileCompletionTopPopup";
import ProfileCompletionModal from "./components/ProfileCompletionModal";

import { useSearchParams } from "react-router-dom";
import ApplicationFormV2 from "./components/steps/ApplicationFormV2/ApplicationFormV2";
import VerifyAccount from "@/pages/authentication/signUp/steps/VerifyAccount";
import VerifyAccountByGoogle from "@/pages/authentication/signUp/steps/VerifyAccountByGoogle";
import Logo from "@/assets/logo/logo-with-text.png";

const SignUpV2 = () => {
  const [searchParams] = useSearchParams();

  const stepParam = searchParams.get("step");
  const googleVerify = searchParams.get("googleVerify");

  const [currentStep, setCurrentStep] = useState(
    stepParam ? Number(stepParam) : 1,
  );

  const [completedSteps, setCompletedSteps] = useState<Set<number>>(new Set());

  const [userEmail, setUserEmail] = useState<string>("");
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  // Lock scroll when modal open (mobile)
  useEffect(() => {
    document.body.style.overflow = isProfileModalOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isProfileModalOpen]);

  const steps = [
    { id: 1, title: "Create Account" },
    { id: 2, title: "Verify Account" },
    { id: 3, title: "Application Form" },
  ];

  const handleNext = (stepId: number, email?: string) => {
    setCompletedSteps((prev) => new Set([...prev, stepId]));

    if (email) {
      setUserEmail(email);
    }

    setCurrentStep(stepId + 1);
  };

  const handleGoToStep = (stepId: number) => {
    setCurrentStep(stepId);
  };

  return (
    <div className="w-full">
      {/* header */}
      <div className="sticky top-0 left-0 right-0 bg-[#F8F8F8] z-[51]">
        <div className="relative bg-white flex justify-between items-center py-4 px-4 md:px-20 w-full">
          <img src={Logo} className="w-[120px]" alt="passionbits-logo" />
        </div>
      </div>
      <div className="px-4 sm:px-6 lg:px-0 pt-4 pb-10 lg:py-[50px]">
        {/* ✅ MOBILE ONLY: Top popup */}
        {currentStep !== 1 && (
          <div className="lg:hidden flex items-center justify-center mb-4">
            <ProfileCompletionTopPopup
              currentStep={currentStep}
              onOpen={() => setIsProfileModalOpen(true)}
            />
          </div>
        )}

        {/* ✅ MOBILE ONLY: Modal */}
        <div className="lg:hidden">
          <ProfileCompletionModal
            open={isProfileModalOpen}
            onClose={() => setIsProfileModalOpen(false)}
            currentStep={currentStep}
          />
        </div>

        <div className="lg:min-h-[80vh] flex items-center justify-center ">
          <div className="relative w-full flex justify-center ">
            {/* CENTERED FORM */}
            <section className="border border-[#D8D8DD] w-full max-w-[575px] p-4 sm:p-6 rounded-2xl bg-white">
              {currentStep === 1 && (
                <CreateAccountV2
                  onNext={(email?: string) => handleNext(1, email)}
                />
              )}

              {currentStep === 2 && (
                <>
                  {googleVerify ? (
                    <VerifyAccountByGoogle onNext={() => handleNext(2)} />
                  ) : (
                    <VerifyAccount
                      email={userEmail}
                      onVerificationSuccess={() => handleNext(2)}
                    />
                  )}
                </>
              )}

              {currentStep === 3 && <ApplicationFormV2 />}
            </section>

            {/* DESKTOP PROFILE CARD */}
            {currentStep !== 1 && currentStep !== 2 && (
              <div className="hidden lg:block absolute top-0 left-[calc(50%+316px)]">
                <ProfileCompletionCard currentStep={currentStep} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpV2;
